// Client-side mirror of the balance engine for the live meter (see backend/calc.py)
export const DEFAULT_BUCKET_WEIGHTS = [8, 10, 10, 10, 10, 10, 9];

export function weekdayIndex(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.getDay(); // 0=Sun..6=Sat
}

export function computeBalance(entry, bucketWeights = DEFAULT_BUCKET_WEIGHTS) {
  const bw = bucketWeights[weekdayIndex(entry.date)] ?? 10;
  const workers = entry.workers || [];
  const allocations = entry.allocations || [];
  const poolKgs = Number(entry.pool_kgs) || 0;
  const poolWorkers = workers.filter((w) => w.type === "pool");
  const poolMinutes = poolWorkers.reduce((s, w) => s + (Number(w.number) || 0), 0);

  let bucketDirect = 0;
  const computed = workers.map((w) => {
    const num = Number(w.number) || 0;
    let earned = 0;
    if (w.type === "pool") earned = poolMinutes > 0 ? (num / poolMinutes) * poolKgs : 0;
    else if (w.type === "buckets") { earned = num * bw; bucketDirect += earned; }
    else if (w.type === "direct") { earned = num; bucketDirect += earned; }
    return { ...w, earned_kg: Math.round(earned * 100) / 100 };
  });

  const totalWorked = Math.round((poolKgs + bucketDirect) * 100) / 100;
  const totalAllocated = Math.round(allocations.reduce((s, a) => s + (Number(a.kg) || 0), 0) * 100) / 100;
  const remaining = Math.round((totalWorked - totalAllocated) * 100) / 100;

  let status = "BALANCED";
  if (!workers.length) status = "NO WORKERS";
  else if (!allocations.length || totalAllocated <= 0) status = "NO PRODUCTS";
  else if (poolWorkers.length && poolMinutes <= 0) status = "CHECK DATA";
  else if (Math.abs(remaining) > 0.01) status = "UNALLOCATED";

  return { totalWorked, totalAllocated, remaining, status, bucketWeight: bw, computed };
}

export const STATUS_STYLES = {
  BALANCED: { bg: "bg-leaf", text: "text-navy", border: "border-l-emerald-500", dot: "bg-emerald-500", label: "Balanced" },
  UNALLOCATED: { bg: "bg-amber", text: "text-navy", border: "border-l-yellow-500", dot: "bg-yellow-500", label: "Unallocated" },
  "CHECK DATA": { bg: "bg-red-50", text: "text-red-700", border: "border-l-red-500", dot: "bg-red-500", label: "Check Data" },
  "NO WORKERS": { bg: "bg-slate-100", text: "text-slate-600", border: "border-l-slate-400", dot: "bg-slate-400", label: "No Workers" },
  "NO PRODUCTS": { bg: "bg-slate-100", text: "text-slate-600", border: "border-l-slate-400", dot: "bg-slate-400", label: "No Products" },
};

export const money = (n) => `$${(Number(n) || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const kg = (n) => `${(Number(n) || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
